import { render, staticRenderFns } from "./ChannelCard.component.vue?vue&type=template&id=300af3d3&scoped=true&"
import script from "./ChannelCard.component.vue?vue&type=script&lang=js&"
export * from "./ChannelCard.component.vue?vue&type=script&lang=js&"
import style0 from "./ChannelCard.component.vue?vue&type=style&index=0&id=300af3d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300af3d3",
  null
  
)

export default component.exports